import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCurrentLang } from "../hooks/useCurrentLang";
import { contactPageContent } from "../data/contactPageContent";
import GlassCard from "../components/GlassCard";
import image from "../images/white-logo.png";

export const ContactPage = ({ lang = "en" }) => {
  const currentLang = useCurrentLang();
  const t = contactPageContent[currentLang];

  return (
    <div
      className="page page--about"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header lang={currentLang} />

      <main style={{ flex: 1 }}>
        <section
          className="page-section page-section--about-main"
          style={{
            minHeight: "calc(100vh - 220px)",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            paddingTop: "3rem",
            paddingBottom: "5rem",
          }}
        >
          <div
            className="content-narrow about-layout about-layout--balanced"
            style={{
              width: "100%",
              maxWidth: "1200px",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "24px",
              margin: "0 auto",
            }}
          >
            <GlassCard
              style={{
                width: "100%",
                maxWidth: "560px",
                minHeight: "300px",
              }}
            >
              <h2>{t.title}</h2>

              <div
                style={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "left",
                  gap: "2rem",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{
                    width: 88,
                    height: 88,
                    borderRadius: "999px",
                    backgroundColor: "#176B87",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 30,
                    fontWeight: 700,
                    flexShrink: 0,
                  }}
                >
                  <img
                    src={image}
                    alt="Revimo logo"
                    style={{ maxHeight: "80px", maxWidth: "80px" }}
                  />
                </div>

                <ul
                  className="about-stats"
                  style={{
                    justifyContent: "space-between",
                    marginLeft: "0",
                    flex: 1,
                    minWidth: "260px",
                  }}
                >
                  <li>
                    <span className="label">{t.contact.name}</span>
                    <span className="value">Revimo</span>
                  </li>
                  <li>
                    <span className="label">{t.contact.email}</span>
                    <span className="value">
                      <a href="mailto:info@revimo.eu">info@revimo.eu</a>
                    </span>
                  </li>
                  <li>
                    <span className="label">{t.contact.support}</span>
                    <span className="value">
                      <a href="mailto:help@revimo.eu">help@revimo.eu</a>
                    </span>
                  </li>
                  <li>
                    <span className="label">{t.contact.location}</span>
                    <span className="value">{t.contact.locationACC}</span>
                  </li>
                  <li>
                    <span className="label">{t.contact.responseTime}</span>
                    <span className="value">{t.contact.responseTimeValue}</span>
                  </li>
                </ul>
              </div>
            </GlassCard>

            <GlassCard
              style={{
                width: "100%",
                maxWidth: "560px",
                minHeight: "300px",
              }}
            >
              <h3 style={{ marginBottom: "1rem" }}>{t.topicsTitle}</h3>

              <ul
                className="about-stats"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                  gap: "1.25rem",
                }}
              >
                <li>
                  <span className="label">{t.topics.support}</span>
                  <span className="value">{t.topics.supportValue}</span>
                </li>
                <li>
                  <span className="label">{t.topics.business}</span>
                  <span className="value">{t.topics.businessValue}</span>
                </li>
                <li>
                  <span className="label">{t.topics.feedback}</span>
                  <span className="value">{t.topics.feedbackValue}</span>
                </li>
              </ul>
            </GlassCard>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <GlassCard
                style={{
                  width: "100%",
                  maxWidth: "560px",
                  minHeight: "215px",
                  marginBottom: "24px",
                }}
              >
                <h3 style={{ marginBottom: "1rem" }}>{t.optionsTitle}</h3>

                <ul className="about-stats" style={{ gap: "1rem" }}>
                  <li>
                    <span className="label">{t.options.general}</span>
                    <span className="value">
                      <a href="mailto:info@revimo.eu">info@revimo.eu</a>
                    </span>
                  </li>
                  <li>
                    <span className="label">{t.options.support}</span>
                    <span className="value">
                      <a href="mailto:help@revimo.eu">help@revimo.eu</a>
                    </span>
                  </li>
                </ul>
              </GlassCard>
            </div>
          </div>
        </section>
      </main>

      <Footer lang={currentLang} />
    </div>
  );
};